import { useFakedUID } from "./useFakeUID";
import useFirebaseData from "./useFirebaseData";
import type { Firing } from "../types";

const useFirebaseFiring = (firing_id: string) => {
  const uid = useFakedUID();
  return useFirebaseData<Firing>(uid && firing_id ? `/userdata/${uid}/firings/${firing_id}` : null);
};

export default useFirebaseFiring;
